// import HyperLinkColumn from "@/components/functionals/HyperLinkColumn.vue";
import HyperlinkForResultsStatus from "@/components/functionals/HyperlinkForResultsStatus";

const ColumnsBudge2 = [
  {
    prop: "cuenta",
    name: "CUENTA",
    label: "CUENTA",
    minWidth: 120,
    fixed: true,
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "nombre",
    name: "NOMBRE DE LA CUENTA",
    label: "NOMBRE DE LA CUENTA",
    minWidth: 250,
    fixed: true,
    formatter: HyperlinkForResultsStatus
  },
  {
    prop: "pres0",
    name: "PRESUPUESTO",
    label: "PRESUPUESTO",
    minWidth: 150,
    formatter: HyperlinkForResultsStatus,
    cellAtrrs: {
      mes: 4
    }
  },
  {
    prop: "ejec1",
    name: "EJECUCIÓN",
    label: "EJECUCIÓN",
    minWidth: 150,
    formatter: HyperlinkForResultsStatus,
    cellAtrrs: {
      mes: 4
    }
  },
  {
    prop: "var1",
    name: "VARIACIÓN",
    label: "VARIACIÓN",
    minWidth: 150,
    formatter: HyperlinkForResultsStatus,
    cellAtrrs: {
      mes: 5
    }
  },
  {
    prop: "tot",
    name: "Total",
    label: "%",
    minWidth: 150,
    formatter: HyperlinkForResultsStatus
  }
];

export default ColumnsBudge2;
